// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2076":"common","7604":"modules/hero/hero"}[chunkId] + ".css";
};